<template>
	<div ref="carouselContainer" class="carousel-container overflow-hidden min-w-full">
		<div
			ref="carouselContent"
			class="flex min-w-full *:whitespace-nowrap"
			:class="{ 'carousel-move': isCarousel, 'carousel-static': !isCarousel }"
		>
			<template v-if="isCarousel">
				<slot></slot>
				<div class="flex-shrink-0 w-2 bg-gray-100"></div>
			</template>
			<div ref="carouselInitial" class="flex-shrink-0 flex min-w-full *:whitespace-nowrap">
				<slot></slot>
			</div>
			<template v-if="isCarousel">
				<div class="flex-shrink-0 w-2 bg-gray-100"></div>
				<slot></slot>
			</template>
			<template v-if="isCarousel">
				<div class="flex-shrink-0 w-2 bg-gray-100"></div>
				<slot></slot>
				<div class="flex-shrink-0 w-2 bg-gray-100"></div>
			</template>
		</div>
	</div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from "vue";
import { onResize } from "@js/throttle.js"

const isCarousel = ref(false);
const carouselContainer = ref(null);
const carouselContent = ref(null);
const carouselInitial = ref(null);

const checkCarousel = async () => {
	if (carouselContainer.value && carouselContent.value &&	carouselInitial.value) {
		const containerWidth = carouselContainer.value.getBoundingClientRect().width;
		const initialWidth = carouselInitial.value.getBoundingClientRect().width;

		isCarousel.value = initialWidth > containerWidth;
		carouselContent.value.style.setProperty("--carousel-width", `${initialWidth}px`);

		/* calculate animation speed dynamically so it is uniform regardless of the number of items in the carousel */
		const xSpeed = 60; /* tweak this number to change carousel speed - higher = faster, lower = slower */
		carouselContent.value.style.setProperty("--carousel-x-duration", `${initialWidth / xSpeed}s`);
	}
};

onMounted(() => {
	checkCarousel();
	onResize(checkCarousel);
});

onBeforeUnmount(() => {
	window.removeEventListener("resize", checkCarousel);
});
</script>

<style scoped>
.carousel-move {
	animation: carousel-x var(--carousel-x-duration) linear infinite;
}

@keyframes carousel-x {
	0% {
		transform: translateX(0%);
	}
	100% {
		transform: translateX(calc(-1 * var(--carousel-width) - theme(spacing.2)));
	}
}

.carousel-container:has(.carousel-move) {
	mask-image: linear-gradient(to right, transparent, black 32px, black calc(100% - 32px), transparent);
}
</style>
